// Modules
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import moment from 'moment';

import { Page, PageHeader, PageContent, ActionSection } from 'components/page';
import { SortableTH } from 'components/content-containers/tables';
import { Table } from 'components/content-containers/tables/tables';
import { alerts } from 'modules/alerts/actions';
import { didQueryUpdate } from 'utils/filter-utils';
import { mergeQuery } from 'modules/history/actions';
import Filters from 'modules/filters/filters';
import FlipMove from 'components/widgets/animation/flip-move';
import TimeReport from 'services/data/time-report';
import TimeReportRow from 'components/models/time-report/time-report-row';
import replaceById from 'utils/replace-by-id';

import * as actions from './store/actions';


// Component
class TimeReports extends React.Component {
  static propTypes = {
    timeReports: PropTypes.array,
    fetching: PropTypes.bool,
    count: PropTypes.number,
    query: PropTypes.object,
    users: PropTypes.array,
    currentUser: PropTypes.object.isRequired
  };

  constructor() {
    super();

    this.search = this.search.bind(this);
    this.eagerUpdate = this.eagerUpdate.bind(this);

    this.filterConfig = {
      basic: ['search'],
      advanced: [
        ['search', 'company', 'team', 'multiAgreement'],
        ['createdBy', 'date']
      ],
      defaults: () => ({
        date: { min: moment().startOf('day').toDate() },
        createdBy: [this.props.currentUser.id]
      }),
      autoFilters: [[
        { label: 'Today', fn: () => this.setDate(0), active: filters => _.isEqual(filters.date, this.setDate(0, false)) },
        { label: '-1D', fn: () => this.setDate(1), active: filters => _.isEqual(filters.date, this.setDate(1, false)) },
        { label: '-7D', fn: () => this.setDate(7), active: filters => _.isEqual(filters.date, this.setDate(7, false)) }
      ]]
    };
  }

  componentWillReceiveProps(nextProps) {
    if (didQueryUpdate(nextProps, this.props)) this.search(nextProps.query);
  }

  setDate(n, set = true) {
    const date = { min: moment().startOf('day').subtract(n, 'days').toISOString() };

    if (set) mergeQuery({ where: { date } }, true);

    return date;
  }

  search(query) {
    actions.set({ fetching: true });
    const fullQuery = TimeReport.formatQuery(query || this.props.query);
    delete fullQuery.limit;

    return TimeReport.find(fullQuery)
      .then((timeReports) => {
        actions.set({ fetching: false, timeReports });
      })
      .catch(alerts.catchError);
  }

  eagerUpdate(values) {
    const { timeReports } = this.props;
    const report = _.find(timeReports, { id: values.id });
    const rate = values.rate ? _.find(report.agreement.rates, { id: values.rate }) || report.rate : null;
    const update = _.defaults({ rate }, values, report);

    actions.set({ timeReports: replaceById(update, timeReports) });
  }

  render() {
    const { timeReports = [], fetching } = this.props;
    const totalTime = _.reduce(timeReports, (total, report) => total + Number(report.duration), 0);
    const fullQuery = TimeReport.formatQuery(this.props.query);

    const headerActions = (
      <div className="header-actions">
        <a className="button btn-success" href={TimeReport.getExportActionsUrl(fullQuery)}>Export Actions Report</a>
        <a className="button btn-success" href={TimeReport.getExportUrl(fullQuery)}>Export</a>
      </div>
    );

    return (
      <Page>
        <PageHeader title="Time Reports" actions={headerActions}>
          <ActionSection>
            <Filters config={this.filterConfig} />
          </ActionSection>
        </PageHeader>
        <PageContent
          fetching={fetching}
          emptyText="No time reports, adjust your filters!"
          emptyTextIcon="svg/time-report.svg"
          showEmptyText={!fetching && _.isEmpty(timeReports)}
          className="time-reports"
        >
          <div className="time-table">
            <Table>
              <thead>
                <tr>
                  <SortableTH className="collapse-width" sortField="date">Date</SortableTH>
                  <SortableTH className="collapse-width" sortField="createdBy.firstName">User</SortableTH>
                  <SortableTH className="collapse-width" sortField="agreement.company.name">Company</SortableTH>
                  <th className="collapse-width">Agreement</th>
                  <th>Ticket</th>
                  <SortableTH sortField="description">Description</SortableTH>
                  <SortableTH className="collapse-width right-align" sortField="duration">Time</SortableTH>
                  <th className="collapse-width"></th>
                </tr>
              </thead>
              <FlipMove typeName="tbody" enterAnimation="fade" leaveAnimation="fade">
                {_.map(timeReports, (report) => <TimeReportRow key={report.id} report={report} eagerUpdate={this.eagerUpdate} />)}
                <tr className="total-row">
                  <td colSpan="6">Total Time</td>
                  <td className="right-align">{totalTime.toFixed(2)}</td>
                  <td></td>
                </tr>
              </FlipMove>
            </Table>
          </div>
        </PageContent>
      </Page>
    );
  }
}

// Exports
export default connect((state) => ({
  timeReports: state.timeReports.timeReports,
  fetching: state.timeReports.fetching,
  users: state.pageData.selectUsers,
  count: state.timeReports.count,
  query: state.location.query,
  currentUser: state.auth.currentUser
}))(TimeReports);



// WEBPACK FOOTER //
// ./app/routes/time-report/view-time-reports.js